import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import WaistForm from '../components/WaistForm';
import WaistHistory from '../components/WaistHistory';

export default function WaistPage({ history = false }) {
  const navigate = useNavigate();
  useEffect(() => { document.title = history ? '腰圍歷史紀錄' : '新增腰圍紀錄'; }, [history]);
  return <div className="container mt-4"><h2>{history ? '腰圍歷史紀錄' : '新增腰圍紀錄'}</h2>
    <div className="my-3"><Link className="btn btn-success me-2" to={history ? '/waist/new' : '/waist/history'}>{history ? '新增腰圍' : '腰圍歷史紀錄'}</Link><Link className="btn btn-outline-secondary" to="/dashboard">回到目錄</Link></div>
    {history ? <WaistHistory /> : <WaistForm onSuccess={() => navigate('/waist/history')} />}
  </div>;
}
